import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSetState } from '../../../AppState';

/**
 * For a ticket page: a comment put away while the activity tab was closed is discarded on any
 * route change, which the leave prompt has already let through - leaving the ticket, or clicking
 * it again to reload it. The comment box does the same for a draft it holds open.
 */
export const useDiscardDraftOnLeave = (): void => {
  const setState = useSetState();
  const location = useLocation();
  const openedAt = useRef(location.key);
  useEffect(() => {
    if (location.key === openedAt.current) return;
    openedAt.current = location.key;
    setState(s => (s.draftComment ? { ...s, draftComment: null } : s));
  }, [location.key]);
};
